import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;
const isProduction = process.env.NODE_ENV === "production";

function reportError(message, context) {
  try {
    const request = axios.post(`${REACT_APP_BASE_URL}/error-log`, {
      level: "error",
      message,
      context,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      timestamp: new Date().toISOString(),
    });
    if (request && typeof request.catch === "function") request.catch(() => {});
  } catch (e) {
    // A logger must never throw while reporting a failure.
  }
}

const logger = {
  debug: (message, context) => {
    if (!isProduction) console.debug(`[DEBUG] ${message}`, context || "");
  },
  info: (message, context) => {
    if (!isProduction) console.info(`[INFO] ${message}`, context || "");
  },
  warn: (message, context) => {
    if (!isProduction) console.warn(`[WARN] ${message}`, context || "");
  },
  error: (message, context) => {
    if (!isProduction) console.error(`[ERROR] ${message}`, context || "");
    reportError(message, context);
  },
};

export default logger;
